import { createFileRoute } from '@tanstack/react-router'

import DetailApbnApbdPage from '@/components/pages/backoffice/_ktg-penyuluh/apbn-apbd/$apbnApbd/containers/DetailApbnApbdPage'

export const Route = createFileRoute('/_backoffice/ktg-penyuluh/apbd/$apbdId/')(
  {
    component: RouteComponent
  }
)
function RouteComponent() {
  const id = Route.useParams().apbdId
  return <DetailApbnApbdPage type="APBD" id={id} />
}
